import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { mainApiService } from 'api/config'
import { Block } from 'utils/block'

export const BLOCKS_QUERY_KEY = 'blocks'

type FetchBlockParams = {
  userId?: string
  areaId?: string
}

export const useGetBlocks = ({ userId, areaId }: FetchBlockParams) => {
  const { data, ...result } = useQuery({
    queryKey: [BLOCKS_QUERY_KEY, userId, areaId],
    queryFn: () => mainApiService.getList<Block>('blocks', { objectId: areaId, userId }),
    enabled: !!userId && !!areaId,
  })

  return {
    ...result,
    data: data || [],
  }
}

export const useCreateBlock = ({ userId, areaId }: FetchBlockParams) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (title: string) =>
      mainApiService.createItem<Block>('blocks', {
        title: title,
        objectId: areaId,
        userId,
        content: [
          {
            type: 'heading',
            attrs: {
              class: null,
              textAlign: 'left',
            },
            content: [
              {
                type: 'text',
                text: title,
              },
            ],
          },
        ],
      }),
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BLOCKS_QUERY_KEY],
      })
    },
  })
}
